/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr';

interface AddRestaurantHeaderProps {
  restaurantId: string; // Assuming restaurantId is of type string, adjust as needed
}
const AddRestaurantHeader: React.FC<AddRestaurantHeaderProps> = ({ restaurantId }) => {
  const t = Tr()
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const location = useLocation();
  const editRestaurantId = (location.state as any)?.restaurantId || '';

  const [restaurantDetails, setRestaurantDetails] = useState([]);

  // restaurant Details api call
  const restaurantDetailsApiCall = async () => {

    var param: any = {
      vendorId: vendorId,
      'restaurantId': editRestaurantId
    }
    var response: any = await fetchData("public/restaurantDetail", param)

    if (response.status == "200") {
      var restaurantData = response.data
      setRestaurantDetails(restaurantData);
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editRestaurantId != "") {
      restaurantDetailsApiCall()
    }
  }, [])

  const tabRefs = useRef([]) as any;
  const indexTab = sessionStorage.getItem('indexTab') || 0;

  useEffect(() => {
    const scrollToTab = () => {
      // Check if the tabRefs array is populated and if the indexTab element exists
      if (tabRefs.current.length > 0 && tabRefs.current[indexTab]) {
        // Delay scrollIntoView to ensure all rendering is complete
        setTimeout(() => {
          tabRefs?.current[indexTab]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',  // Scroll vertically to nearest edge
            inline: 'center'   // Scroll horizontally to center
          });
        }, 700);
      }
    };
    scrollToTab();
    // Add event listener for window load event to handle case of page refresh
    window.addEventListener('load', scrollToTab);
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('load', scrollToTab);
    };
  }, [location, indexTab]);
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['basicInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantbasicinfo/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantbasicinfo/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantbasicinfo/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['location'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantlocation/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantlocation/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantlocation/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['propertyDetail'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['propertyDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantdetails/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['propertyDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantdetails/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Property Details')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['propertyDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantdetails/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['propertyDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Property Details')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['menu'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['menu'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantmenu/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['menu'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantmenu/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Menu')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['menu'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantmenu/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['menu'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Menu')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['photos'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantphotos/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantphotos/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Photos')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantphotos/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Photos')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['facilitiesAndServices'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['facilitiesAndServices'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantfacilities/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['facilitiesAndServices'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantfacilities/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Facilities & Services')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['facilitiesAndServices'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantfacilities/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['facilitiesAndServices'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Facilities & Services')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['availability'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['availability'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantavailability/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['availability'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantavailability/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Availability')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['availability'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantavailability/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['availability'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Availability')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['policies'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantpolicies/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantpolicies/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Policies')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantpolicies/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Policies')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['financeAndLegal'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantfinance/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addrestaurantfinance/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Finance & Legal')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addrestaurantfinance/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Finance & Legal')}
                    </button>
                  )
                }
              </li>
              {/* <li className='nav-item'>
                {
                  restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['contract'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewrestaurantcontract/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewrestaurantcontract/'
                      state={{ restaurantId: editRestaurantId }}
                      ref={el => (tabRefs.current[9] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '9')}
                    >
                      {t('Contract Agreement')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewrestaurantcontract/' ? `${restaurantDetails && restaurantDetails.length > 0 && restaurantDetails[0]['completedSteps'] && restaurantDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[9] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '9')}
                    >
                      {t('Contract Agreement')}
                    </button>
                  )
                }
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export { AddRestaurantHeader }
